export const dialogsReducerKey = 'dialogsReducer';

export const updateDialogType = 'UPDATE_DIALOG';
export const closeDialogType = 'CLOSE_DIALOG';
export const removeDialogType = 'removeDialogType';
export const LEGACY_DIALOG_SIZE = '31.875rem';
